export const RewardKeys = {
  all: ["rewards"] as const,
  reward: () => [...RewardKeys.all, "detail"] as const,
  lists: () => [...RewardKeys.all, "list"] as const,
  list: (filters: { name?: string | null; offset: number; limit: number }) =>
    [...RewardKeys.lists(), filters] as const,
  detail: (id: number) => [...RewardKeys.reward(), id] as const,
};

export const rewardMutationKeys = {
  create: ["createReward"],
  update: ["updateReward"],
  createOrUpdate: ["createOrUpdateReward"],
} as const;
